const jQ = jQuery.noConflict();

class ContentFadeIn {
    init() {
        this.cacheDom();
        this.bindEvents();
    }
    cacheDom() {
        this.$baseElements = jQ('section.animate-content-in').find('p, ul, ol, h1, h2, h3, h4, h5, h6, hr, span, figure, img, iframe, blockquote, button, a.btn, table, [type="submit"]');
        this.$customElements = jQ('.inview-wrapper, .summary.entry-summary');
    }
    bindEvents() {
        this.$baseElements.one('inview', this.showElements);
        this.$customElements.one('inview', this.showElements);
    }
    showElements(a, b) {
        if(!jQ(this).hasClass('not-animated') && jQ(this).parent('.image-gallery-slide-img').length == 0){
            jQ(this).addClass('isFadeIn');
        }
    }
    showCustomElements() {
        if(!jQ(this).hasClass('not-animated')){
            jQ(this).addClass('isFadeIn');
        }
    }
}

const contentFade = new ContentFadeIn();

export default contentFade;
